var exports = {
  "a": "Box__Bx7KD_",
  "K": "IconButton__5cdSEl",
};

module.exports = exports;
